var _templateObject = _taggedTemplateLiteralLoose(['\n  min-height: ', ';\n'], ['\n  min-height: ', ';\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Container = styled.div(_templateObject, function (props) {
  return props.height ? props.height : props.theme.minheight;
});

var Minheight = function Minheight(props) {
  return React.createElement(Container, {
    height: props.height
  }, props.children);
};

export default Minheight;